import "./ReoForm.css.ts.vanilla.mjs";
var e = "p273__ReoForm-1379_fc0594b3e__4m7fwe1", r = "p273__ReoForm-1379_fc0594b3e__4m7fwe3", o = "p273__ReoForm-1379_fc0594b3e__4m7fwe0", m = "p273__ReoForm-1379_fc0594b3e__4m7fwe4", f = "p273__ReoForm-1379_fc0594b3e__4m7fwe5", a = "p273__ReoForm-1379_fc0594b3e__4m7fwe6", i = "p273__ReoForm-1379_fc0594b3e__4m7fwe2";
export {
  e as horizontal,
  r as inline,
  o as reoForm,
  m as sizeLarge,
  f as sizeMedium,
  a as sizeSmall,
  i as vertical
};
//# sourceMappingURL=ReoForm.mjs.map
